module.exports = __webpack_public_path__ + "static/egyptian-fitted-sheet-grey-1-aa2bdcaff7161a079ae6fe334755a03c.png";